import http from "@/utils/http";
let hr = "/hrApi";
// let host = "/oaApi/nvc/public";
// // let qrcode = "/qrcodeApi";
// let config = "http://qrcode.nvc-lighting.com.cn";

export default {
  // upload: "http://192.168.200.120:8085", //测试
  // imgUrl: "http://192.168.200.120:8085/file/view/", //测试
  upload: "https://qw.nvc-lighting.com.cn:8082", //正式
  imgUrl: "https://qw.nvc-lighting.com.cn:8082/file/view/", //正式
  getUpload: (data) => http.post(`https://qw.nvc-lighting.com.cn:8082/file/upload`, data,{
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }),
  // 随手拍获得类型列表
  queryByType: (data) => http.post(`${hr}/rs/getType`, data),
  // 随手拍获得位置列表
  queryByPlace: (data) => http.post(`${hr}/rs/getPlace`, data),
  // 我的随手拍
  myRs: (data) => http.post(`${hr}/rs/myRs`, data),
  // 随手拍申请
  apply: (data) => http.post(`${hr}/rs/apply`, data),
  // 随手拍详情
  detail: (data) => http.post(`${hr}/rs/detail`,data),
  // 待审核随手拍列表
  adminRs: (data) => http.post(`${hr}/rs/adminRs`,data),
  // 随手拍管理员处理
  dispose: (data) => http.post(`${hr}/rs/dispose`,data),
  // 随手拍评价
  appraise: (data) => http.post(`${hr}/rs/appraise`,data),
  // 是否是管理员
  isAdmin: (data) => http.post(`${hr}/rs/isAdmin`,data),
  // 月度汇总数据
  getSummarize: (data) => http.post(`${hr}/rs/getSummarize`,data),
  // 后台管理列表
  adminList: (data) => http.post(`${hr}/rs/adminList`,data),
  // 列表导出
  adminListExport: (data) => http.post(`${hr}/rs/adminListExport`,data, {
    responseType: "blob"
  }),
};
